import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/scrollToTop";
import usePageTracking from "./hooks/usePageTracking";
import AboutUs from "./pages/AboutUs";
import CancellationAndRefundPolicy from "./pages/CancellationAndRefundPolicy";
import ContactUs from "./pages/ContactUs";
import Home from "./pages/Home";
import Login from "./pages/Login";
import CorporateWellness from "./pages/Offerings/CorporateW/CorporateWellness";
import Insight from "./pages/Offerings/CorporateW/Insight";
import Thrive from "./pages/Offerings/CorporateW/Thrive";
import OnlinePrograms from "./pages/Offerings/OnlinePrograms";
import Retreats from "./pages/Offerings/Retreat/Retreats";
import Synnergise from "./pages/Offerings/Retreat/Synnergise";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Innergise from "./pages/Offerings/Retreat/Innergise";
import InnerQuiet from "./pages/Offerings/Retreat/InnerQuiet";
import PrakritiQuiz from "./pages/Quizes/Prakritiquiz";
import BodyToxin from "./pages/Quizes/BodyToxin";
import HolisticWellness from "./pages/Quizes/HolisticWellness";
import Quiz from "./pages/Knowyourself/Quiz";
import Blogs from "./pages/Knowyourself/Blogs";
import MayBook from "./pages/book/Maybook";
import Blog1 from "./pages/Blogs/Blog1";
import Blog2 from "./pages/Blogs/Blog2";
import Blog3 from "./pages/Blogs/Blog3";
import Blog5 from "./pages/Blogs/Blog5";
import Blog6 from "./pages/Blogs/Blog6";
import Blog7 from "./pages/Blogs/Blog7";
import Blog4 from "./pages/Blogs/Blog4";
import Blog8 from "./pages/Blogs/Blog8"
import Blog9 from "./pages/Blogs/Blog9";
import Blog10 from "./pages/Blogs/Blog10";
import Blog11 from "./pages/Blogs/Blog11";
import Blog12 from "./pages/Blogs/Blog12";
import Blog13 from "./pages/Blogs/Blog13";
import Blog14 from "./pages/Blogs/Blog14";
import Blog15 from "./pages/Blogs/Blog15";
import Blog16 from "./pages/Blogs/Blog16";
import Blog17 from "./pages/Blogs/Blog17";
import Blog18 from "./pages/Blogs/Blog18";
import Blog19 from "./pages/Blogs/Blog19";
import Blog20 from "./pages/Blogs/Blog20";
import LeadMagnet from "./pages/LeadMagnet";
import { useLocation } from "react-router-dom";
import InnergiseLandingPage from "./pages/landing/InnergiseLandingPage";
import ThankYouPage from "./pages/ThankYouPage";
import InnergiseLandingPage2 from "./pages/landing/InnergiseLandingPage2";
import WebFormPage from "./pages/WebFormPage";
import DataDeletionInstructions from "./pages/DataDeletion";
import SelfLoveQuiz from "./pages/Quizes/SelfLoveQuiz";
import GutHealthQuiz from "./pages/Quizes/GutHealth";
import EmotionalWellbeingQuiz from "./pages/Quizes/EmotionalWellbeing";
import GunaSelfAssessmentQuiz from "./pages/Quizes/GunaAssessment";
import NutritionKnowledgeQuiz from "./pages/Quizes/NutritionKnowledge";
import IntegrityQuiz from "./pages/Quizes/IntegrityQuiz";
import SleepStressAwarenessQuiz from "./pages/Quizes/SleepStressQuiz";
const App = () => {
  const isProd = process.env.REACT_APP_ENV === "PROD"; 

  console.log("Current Environment:", process.env.REACT_APP_ENV);

  usePageTracking();
const location = useLocation();
const params = new URLSearchParams(location.search);
const isEmbed = params.get("embed") === "true";

// Use this to hide both header and footer:
const hideLayout = isEmbed || location.pathname === "/retreat-ingz-oct"|| location.pathname === "/retreat-ingz-oct-lp2";

  useEffect(() => {
    if (isProd) { // ✅ Only load Google Tag in production
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-3GD5Q0QKSY";
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", "G-3GD5Q0QKSY");
      };
    }
  }, [isProd]);

  return (
    <>
    <div className="font-body">

{!hideLayout && <Navbar />}
      <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/retreats" element={<Retreats />} />
        <Route path="/retreats/innergise" element={<Synnergise />} />
        <Route path="/retreats/synnergise" element={<Innergise />} />
        <Route path="/retreats/innerQuiet" element={<InnerQuiet />} />
        <Route path="/corporate-wellness" element={<CorporateWellness />} />
        <Route path="/online-programs" element={<OnlinePrograms/>} />
        <Route path="/wellness-quiz/know-your-prakriti" element={<PrakritiQuiz />} />
        <Route path="/wellness-quiz/body-toxin-level" element={<BodyToxin />} />
        <Route path="/wellness-quiz/holistic-wellness-test" element={<HolisticWellness />} />
        <Route path="/wellness-quiz" element={<Quiz />} />
        <Route
  path="/wellness-quiz/guna-self-assessment"
  element={<GunaSelfAssessmentQuiz />}
/>

<Route
  path="/wellness-quiz/emotional-wellbeing"
  element={<EmotionalWellbeingQuiz />}
/>

<Route
  path="/wellness-quiz/gut-health"
  element={<GutHealthQuiz />}
/>

<Route
  path="/wellness-quiz/self-love"
  element={<SelfLoveQuiz />}
/>
      <Route path="/wellness-quiz/integrity" element={<IntegrityQuiz />} />

      {/* Knowledge-based quizzes */}
      <Route path="/wellness-quiz/nutrition-knowledge" element={<NutritionKnowledgeQuiz />} />
      <Route path="/wellness-quiz/sleep-stress-awareness" element={<SleepStressAwarenessQuiz />} />


        <Route path="/wellness-blogs" element={<Blogs />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/user/login" element={<Login />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-refund-policy" element={<CancellationAndRefundPolicy />} />
        <Route path="/corporate-wellness/thrive" element={<Thrive />} />
        <Route path="/corporate-wellness/insight" element={<Insight />} />
        <Route path="/retreats/innergise/book-oct-retreat" element={<MayBook />} />
        <Route path="/wellness-blogs/four-pillar-approach-of-holistic-well-being" element={<Blog1/>}/>
        <Route path="/wellness-blogs/food-beyond-fuel" element={<Blog2/>}/>
        <Route path="/wellness-blogs/science-of-scattered-minds" element={<Blog3/>}/>
       <Route path="/wellness-blogs/never-do-these-mistakes-after-30" element={<Blog4/>}/>
       <Route path="/wellness-blogs/10-micro-habits-for-massive-shifts" element={<Blog5/>}/>
        <Route path="/wellness-blogs/tiny-morning-habits" element={<Blog6/>}/>
       <Route path="/wellness-blogs/choosing-or-settling" element={<Blog7/>}/>
       <Route path="/wellness-blogs/how-to-control-your-mind" element={<Blog8/>}/>
       <Route path="/wellness-blogs/things-our-grandparents-did-right" element={<Blog9/>}/>
       <Route path="/wellness-blogs/why-life-feels-stuck" element={<Blog10/>}/>
<Route
  path="/wellness-blogs/11-simple-habits-that-protect-your-mental-health-daily"
  element={<Blog11 />}
/>

<Route
  path="/wellness-blogs/9-morning-habits-that-power-up-your-whole-day"
  element={<Blog12 />}
/>

<Route
  path="/wellness-blogs/11-things-to-start-doing-before-you-turn-30"
  element={<Blog13 />}
/>

<Route
  path="/wellness-blogs/9-hidden-signs-your-body-needs-attention"
  element={<Blog14 />}
/>
<Route
  path="/wellness-blogs/7-things-emotionally-intelligent-people-dont-do"
  element={<Blog16 />}
/>

<Route
  path="/wellness-blogs/master-this-habit-and-people-will-stop-triggering-you"
  element={<Blog17 />}
/>

<Route
  path="/wellness-blogs/10-signs-youre-acting-as-your-own-worst-enemy"
  element={<Blog18 />}
/>

<Route
  path="/wellness-blogs/8-everyday-triggers-that-are-silently-destroying-your-gut"
  element={<Blog15 />}
/>
<Route
  path="/wellness-blogs/9-health-priorities-every-woman-over-25"
  element={<Blog19 />}
/>
<Route
  path="/wellness-blogs/9-habits-women-over-30-should-ditch-for-hormonal-health"
  element={<Blog20 />}
/>


        <Route path="/download-deep-mental-detox-guide" element={<LeadMagnet/>}/>
        <Route path="/retreat-ingz-oct" element={<InnergiseLandingPage/>}/>
         <Route path="/thank-you-page" element={<ThankYouPage/>}/>
        <Route path="/retreat-ingz-oct-lp2" element={<InnergiseLandingPage2/>}/>
        <Route path="/retreat-inquiry-form" element={<WebFormPage/>}/>
        <Route path="/user-data-deletion" element={<DataDeletionInstructions/>}/>

      </Routes>
     

     {!hideLayout &&  <Footer />}
     {!hideLayout && (


      <a 
  href="https://wa.me/+918279445944" 
  target="_blank" 
  rel="noopener noreferrer"
  className="fixed bottom-10 mb-2 right-1 md:bottom-20 md:right-6 p-2 md:p-5 rounded-full z-[9999] "
>
  <img src="/whatsapp-icon.png" alt="WhatsApp" className="w-10 h-10 md:w-12 md:h-12" />
</a>)}
</div>
    </>
  );
};

export default App;
